import { memo } from "react";
import { useTranslation } from "react-i18next";
import {
  ChatCloseIcon,
  ChatLockIcon,
  ChatWarningIcon,
} from "components/shared/svg-action-icons";

const ChatAccessDenied = ({ onClose, variant = "compact" }) => {
  const { t } = useTranslation();
  const isCompact = variant === "compact";

  if (isCompact) {
    return (
      <section className="chat-container w-[92vw] sm:w-[432px] h-[550px] bg-surface rounded-[18px] chat-sh overflow-hidden flex flex-col relative animate-fade-in border border-border-light">
        <div className="chat-header bg-chrome-raised text-surface h-[68px] px-6 flex items-center justify-between flex-shrink-0">
          <div className="flex items-center gap-3">
            <div className="w-[34px] h-[34px] rounded-full bg-primary/10 flex items-center justify-center">
              <ChatWarningIcon className="w-5 h-5 text-white" />
            </div>
            <span className="text-sm font-semibold">{t("chat.title")}</span>
          </div>
          <button
            type="button"
            onClick={onClose}
            className="text-white/80 hover:text-white transition"
          >
            <ChatCloseIcon />
          </button>
        </div>
        <div className="flex-1 flex flex-col items-center justify-center p-8 bg-surface-muted text-center">
          <div className="w-16 h-16 rounded-full bg-danger/10 flex items-center justify-center mb-4">
            <ChatLockIcon className="w-8 h-8 text-danger" />
          </div>
          <h3 className="text-lg font-bold text-text-strong mb-2">
            {t("chat.access_denied")}
          </h3>
          <p className="text-sm text-text-muted leading-relaxed">
            {t("chat.no_permission")}
          </p>
        </div>
      </section>
    );
  }

  return (
    <div className="fixed inset-0 z-[800] flex items-center justify-center bg-black/60 p-4">
      <section className="w-full max-w-lg bg-surface rounded-2xl shadow-2xl overflow-hidden flex flex-col h-[400px]">
        <div className="bg-chrome-raised text-surface px-6 py-4 flex items-center justify-between">
          <span className="font-bold text-base">{t("chat.title")}</span>
          <button
            type="button"
            onClick={onClose}
            className="text-white/80 hover:text-white transition"
          >
            <ChatCloseIcon className="w-6 h-6" />
          </button>
        </div>
        <div className="flex-1 flex flex-col items-center justify-center p-8 bg-surface-muted text-center">
          <div className="w-16 h-16 rounded-full bg-danger/10 flex items-center justify-center mb-4">
            <ChatLockIcon className="w-8 h-8 text-danger" />
          </div>
          <h3 className="text-lg font-bold text-text-strong mb-2">
            {t("chat.access_denied")}
          </h3>
          <p className="text-sm text-text-muted">{t("chat.no_permission")}</p>
        </div>
      </section>
    </div>
  );
};

export default memo(ChatAccessDenied);
